module.exports = __webpack_public_path__ + "img/home-index-menu4.7ea44e11.png";